import { render, staticRenderFns } from "./VantVipSucPop.vue?vue&type=template&id=87c3b8b2&"
import script from "./VantVipSucPop.vue?vue&type=script&lang=js&"
export * from "./VantVipSucPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports